import { post } from '../index';

export const changeExpirationDate = body => {
  return post('/company/change-expiration', body);
};
